import { useEventBus } from "@vueuse/core";

const bridgeBusKey = Symbol("bridge");
export function useBusEmitter<TPayload = void>(event: symbol) {
  return (payload: TPayload) => {
    const bus = useEventBus(bridgeBusKey);
    bus.emit(event, payload);
  };
}

export function useBusListener<TPayload = void>(event: symbol) {
  return (listener: (payload: TPayload) => void) => {
    const bus = useEventBus(bridgeBusKey);
    bus.on((busEvent, payload: TPayload) => {
      if (busEvent === event) {
        listener(payload);
      }
    });
  };
}

export function useBusEmitterListener<TPayload = void>(eventName: symbol) {
  return {
    emitter: useBusEmitter<TPayload>(eventName),
    listener: useBusListener<TPayload>(eventName),
  };
}
